<template>
	<layout-admin>
		<ui-alert
			v-if="success"
			type="success"
			:message="success == true ? 'Your inputs have been saved!' : success"
		/>
		<ui-alert v-if="error" type="error" :message="error" />

		<div class="pb-8 px-6 fixed bottom-0 flex right-0 z-10">
			<ui-button
				class="ml-auto text-lg shadow-xl"
				label="Save"
				v-on:click="submitForm()"
				:disabled="submitButtonDisabled"
			/>
		</div>

		<admin-user-fields :user="form" :form="form" :can-advanced="true" />
		<user-edit-base-data
			:user="form"
			:form="form"
			:can-edit-company-type="true"
		/>
		<user-edit-contact-details :user="form" :form="form" />
		<user-edit-bank-account-details :user="form" :form="form" />
		<user-edit-loading-details :user="form" :form="form" />
		<user-edit-notifications :user="form" :form="form" />
	</layout-admin>
</template>

<script>
import Vue from "vue";

export default {
	props: {
		initialData: {
			type: Object,
			required: true,
		},
		success: {
			default: false,
		},
		error: {
			type: String,
			required: false,
		},
	},
	data() {
		return {
			form: Vue.observable(
				this.$inertia.form(
					Object.assign(this.initialData, {
						current_password: null,
						new_password: null,
						new_password_confirmation: null,
						file: null,
						label_id: null,
					})
				)
			),
			submitButtonDisabled: false,
		};
	},
	created() {
		console.log(this.initialData);
	},
	methods: {
		async submitForm() {
			let endpoint = this.$page.url,
				method = "patch",
				that = this;

			this.submitButtonDisabled = true;
			this.form.submit(method, endpoint, {
				preserveState: true,
				onSuccess(p) {
					console.log("SUCCESS SUBMISSION, got: ", p);
				},
				onFinish(e) {
					that.submitButtonDisabled = false;
					console.log("submit FINISH", method, endpoint, "got:", e);
				},
			});
		},
	},
};
</script>
